import { NitexCropTool } from '@nitex/nitex-design-tool';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import '@nitex/nitex-design-tool/dist/index.css';

const NitexImageCropper = ({ isEdit, onClose, imageSrc, onSave }) => {
	const [croppedImageData, setCroppedImageData] = useState('');
	const [showPreview, setShowPreview] = useState(false);

	return (
		<div>
			<Modal
				fullscreen={true}
				size={'xl'}
				centered
				show={isEdit}
				onHide={onClose}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Crop design</h3>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{showPreview && (
						<div className="preview-image">
							<img
								style={{ width: '25%', padding: '12px' }}
								src={croppedImageData}
								alt="cropped"
								className="croped-image"
							/>
						</div>
					)}
					<NitexCropTool imageUrl={imageSrc} setCroppedImageData={setCroppedImageData} />
				</Modal.Body>

				<Modal.Footer>
					<div className="common-popup-footer d-flex justify-content-between">
						<div className="footer-buttons text-right">
							<button
								className="button outline size32"
								onClick={() => {
									onClose();
								}}
							>
								Cancel
							</button>
							<button className="button size32 ml-2" onClick={() => setShowPreview(true)}>
								Preview
							</button>
							<button
								className="button size32 ml-2"
								onClick={() => {
									onSave(croppedImageData);
								}}
							>
								Submit
							</button>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default NitexImageCropper;
